import { Box } from "@chakra-ui/react";
import { useRef, useEffect, useState } from "react";
import JsonRender from "../JsonRender";

type Iprops = {
  showExplanation: boolean;
  explanantion: IConfig[];
};

const Explanation = ({ showExplanation, explanantion }: Iprops) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [explanantion, showExplanation]);

  return (
    <Box>
      <Box
        overflow="hidden"
        height={showExplanation ? `${contentHeight}px` : "0"}
        transition="height 0.3s ease-in-out"
        width="100%"
        bg="whiteAlpha.200"
      >
        <Box ref={contentRef} py="2rem">
          <JsonRender mode="view" content={explanantion} />
        </Box>
      </Box>
    </Box>
  );
};

export default Explanation;
